var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_box"},[_c('div',{staticClass:"text"},[_vm._v("404")]),_c('dl',{staticClass:"content"},[_c('dt',[_vm._v("~~访问的页面找不到了啦~~")]),_c('dd',[_c('router-link',{attrs:{"to":{ path: '/' }}},[_c('i',{staticClass:"fa fa-chevron-circle-left"}),_vm._v(" 返回首页")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }